import React from "react";
import "../../css/tp-sect1.css";
import Ill1LG from "../../assets/images/teacherPage-sect1-img1-lg.png";
import Ill1SM from "../../assets/images/teacherPage-sect1-img1-sm.png";
import Ill2LG from "../../assets/images/teacherPage-sect1-img2-lg.png";
import Ill2SM from "../../assets/images/teacherPage-sect1-img2-sm.png";
import Ill3LG from "../../assets/images/teacherPage-sect1-img3-lg.png";
import Ill3SM from "../../assets/images/teacherPage-sect1-img3-sm.png";

const Sect1 = () => {
  return (
    <section id="tp-sect1">
      <div>
        <div>
          <figure>
            <img className="tp-ill-lg" src={Ill1LG} alt="" />
            <img className="tp-ill-sm" src={Ill1SM} alt="" />
          </figure>
          <article>
            <h2>You can create courses for as many subjects as you want</h2>
            <p>
              Our landing page template works on all devices, so you only have
              to set it up once, and get beautiful results.
            </p>
          </article>
        </div>
        <div>
          <figure>
            <img className="tp-ill-lg" src={Ill2LG} alt="" />
            <img className="tp-ill-sm" src={Ill2SM} alt="" />
          </figure>
          <article>
            <h2>Teach at your own convenience. anytime, anywhere you want</h2>
            <p>
              Our landing page template works on all devices, so you only have
              to set it up once, and get beautiful results.
            </p>
          </article>
        </div>
        <div>
          <figure>
            <img className="tp-ill-lg" src={Ill3LG} alt="" />
            <img className="tp-ill-sm" src={Ill3SM} alt="" />
          </figure>
          <article>
            <h2>
              Get rewarded for delivering quality subject courses for students
            </h2>
            <p>
              Our landing page template works on all devices, so you only have
              to set it up once, and get beautiful results.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Sect1;
